'use client';

import { useTranslations } from 'next-intl';
import type React from 'react';

interface StatCardProps {
  value: string;
  unit: string;
  desc: string;
}

function StatCard({ value, unit, desc }: StatCardProps) {
  return (
    <div className="rounded-8 border border-white/10 bg-white/[0.04] p-6">
      <div className="text-[64px] leading-none tracking-[-0.04em] md:text-[84px]">
        {value}
        <span className="text-[24px] tracking-normal">{unit}</span>
      </div>
      <p className="mt-4 text-[15px] text-white/60 leading-snug">{desc}</p>
    </div>
  );
}

export const PerformanceSection: React.FC = () => {
  const t = useTranslations('vidu-stream.performance');

  return (
    <section
      className="w-full py-24 text-white lg:py-[100px]"
      style={{ background: 'radial-gradient(circle at 50% 44%, #211b30 0%, #131120 53%, #08060c 100%)' }}
    >
      <div className="mx-auto w-full max-w-[1120px] px-6 sm:px-4">
        <div className="grid grid-cols-[1fr_1.1fr] items-center gap-16 sm:grid-cols-1 sm:gap-10">
          {/* 左栏：文案 */}
          <div>
            <p className="mb-4 font-medium text-sm text-white/55 uppercase tracking-wide">{t('eyebrow')}</p>
            <h2 className="text-[64px] leading-[1.05] tracking-tight sm:text-[40px]">{t('title')}</h2>
            <p className="mt-6 max-w-xl text-base text-white/70 leading-snug sm:text-[15px]">{t('description')}</p>
          </div>

          {/* 右栏：数据卡 */}
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-1">
            <StatCard value={t('stat1Value')} unit={t('stat1Unit')} desc={t('stat1Desc')} />
            <StatCard value={t('stat2Value')} unit={t('stat2Unit')} desc={t('stat2Desc')} />
          </div>
        </div>
      </div>
    </section>
  );
};
